import {
	preloadPostOfficePlacementWithSessionContext,
	preloadPlacementTranslations,
} from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

import type { PreloadFnContext } from '@confluence/query-preloader-tools';
import { loadPlacementMessages } from '@post-office-placement/confluence-home-banner/translations';

const PLACEMENT_ID = 'confluence-home-banner';

export const preloadPostOfficeConfluenceHomeBanner = async (
	preloadedSessionContext: PreloadFnContext,
) => {
	return Promise.allSettled([
		preloadPostOfficePlacementWithSessionContext(PLACEMENT_ID, preloadedSessionContext),
		preloadPlacementTranslations(PLACEMENT_ID, () =>
			loadPlacementMessages(preloadedSessionContext.locale),
		),
	]);
};
